//# sourceMappingURL=fractal.mjs.map
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $a from "../../lustre/lustre/attribute.mjs";
import * as $element from "../../lustre/lustre/element.mjs";
import * as $s from "../../lustre/lustre/element/svg.mjs";
import {
  toList,
  Empty as $Empty,
  List$Empty$const as $List$Empty$const,
  CustomType as $CustomType,
} from "../gleam.mjs";

class Fractal extends $CustomType {
  constructor(iteration, dirs) {
    super();
    this.iteration = iteration;
    this.dirs = dirs;
  }
}

class Up extends $CustomType {}
const Dir$Up$const = new Up();

class Down extends $CustomType {}
const Dir$Down$const = new Down();

class Left extends $CustomType {}
const Dir$Left$const = new Left();

class Right extends $CustomType {}
const Dir$Right$const = new Right();

const max_iteration = 12;

const stroke_width = 4;

const step_size = 10;

const start_coord = [105, 400];

export function new$() {
  return new Fractal(0, $List$Empty$const);
}

function rotate(dir) {
  if (dir instanceof Up) {
    return Dir$Left$const;
  } else if (dir instanceof Down) {
    return Dir$Right$const;
  } else if (dir instanceof Left) {
    return Dir$Down$const;
  } else {
    return Dir$Up$const;
  }
}

function unfold(dirs) {
  if (dirs instanceof $Empty) {
    return toList([Dir$Down$const]);
  } else {
    let _pipe = dirs;
    let _pipe$1 = $list.reverse(_pipe);
    let _pipe$2 = $list.map(_pipe$1, rotate);
    return ((_capture) => { return $list.append(dirs, _capture); })(_pipe$2);
  }
}

export function next_iteration(fractal) {
  let $ = fractal.iteration > max_iteration;
  if ($) {
    return new$();
  } else {
    return new Fractal(fractal.iteration + 1, unfold(fractal.dirs));
  }
}

export function iteration(fractal) {
  return fractal.iteration;
}

export function dir_count(fractal) {
  let _pipe = fractal.dirs;
  return $list.length(_pipe);
}

function make_line(c1, c2) {
  let xa = c1[0];
  let ya = c1[1];
  let xb = c2[0];
  let yb = c2[1];
  return $s.line(
    toList([
      $a.attribute("x1", $int.to_string(xa)),
      $a.attribute("x2", $int.to_string(xb)),
      $a.attribute("y1", $int.to_string(ya)),
      $a.attribute("y2", $int.to_string(yb)),
      $a.attribute("stroke-width", $int.to_string(stroke_width)),
      $a.attribute("stroke", "lightgreen"),
    ]),
  );
}

function move(coord, dir) {
  let x = coord[0];
  let y = coord[1];
  if (dir instanceof Up) {
    return [x, y - step_size];
  } else if (dir instanceof Down) {
    return [x, y + step_size];
  } else if (dir instanceof Left) {
    return [x - step_size, y];
  } else {
    return [x + step_size, y];
  }
}

export function view(fractal) {
  let r = $list.map_fold(
    fractal.dirs,
    start_coord,
    (coord, dir) => {
      let new_coord = move(coord, dir);
      let line = make_line(coord, new_coord);
      return [new_coord, line];
    },
  );
  return r[1];
}
